import { feedbackCharm_ariaLabel } from 'owa-locstrings/lib/strings/feedbackcharm_arialabel.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';

import { FeedbackForm } from 'owa-feedback';
import { observer } from 'mobx-react-lite';

const styles = require('./FeedbackPane.scss');

export default observer(function FeedbackPane({ onDismiss }: HeaderPaneProps) {
    return (
        <HeaderFlexPane
            title={loc(feedbackCharm_ariaLabel)}
            content={
                <div className={styles.menuFeedback}>
                    <FeedbackForm onSendFeedback={onDismiss} />
                </div>
            }
            onDismiss={onDismiss}
        />
    );
});
